import { FormFieldType } from '@atom/types/form';

import classes from '../formInstance.module.css';

interface PassedProps {
  field: FormFieldType;
}

type Props = PassedProps;

const DescriptionField = ({ field }: Props) => {
  return (
    <div className={classes.fieldBlock}>
      <div className={classes.descriptionFieldText}>{field.text}</div>
    </div>
  );
};

export default DescriptionField;
